import { authLayout } from "../helpers/withAuth";

export const exploreRoutes = {
  path: "explore",
  ...authLayout("Explore", [
    {
      path: "/explore/",
      lazy: () =>
        import("../../modules/explore").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/movies",
      lazy: () =>
        import("../../modules/explore/pages/movies").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/television",
      lazy: () =>
        import("../../modules/explore/pages/television").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/games",
      lazy: () =>
        import("../../modules/explore/pages/games").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/books",
      lazy: () =>
        import("../../modules/explore/pages/books").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/franchise",
      lazy: () =>
        import("../../modules/explore/pages/franchise").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/companies",
      lazy: () =>
        import("../../modules/explore/pages/companies").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/talent",
      lazy: () =>
        import("../../modules/explore/pages/talent").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/collections",
      lazy: () =>
        import("../../modules/explore/pages/collections").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/anime",
      lazy: () =>
        import("../../modules/explore/pages/anime").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/explore/manga",
      lazy: () =>
        import("../../modules/explore/pages/manga").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};
